/**
 * SettingsView - App settings page
 *
 * Currently supports:
 * - Max cards per review session (slider, 5–100)
 */

import { useEffect } from 'react'
import { useSettings } from '@/hooks/useSettings'
import { useTopBarContent } from '@/contexts/TopBarContent'

export function SettingsView() {
  const { maxCardsPerReview, setMaxCardsPerReview } = useSettings()
  const { setTopBarContent } = useTopBarContent()

  useEffect(() => {
    setTopBarContent(
      <h1 className="font-headline font-bold text-lg text-on-surface">Settings</h1>
    )
  }, [setTopBarContent])

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <span className="material-symbols-outlined text-5xl text-primary mb-4">settings</span>
      <h2 className="font-headline font-bold text-xl text-on-surface mb-6">Settings</h2>

      {/* Max cards per session */}
      <div className="w-full max-w-sm bg-surface-container-lowest rounded-2xl p-6 shadow-card">
        <div className="flex items-center justify-between mb-3">
          <label htmlFor="max-cards" className="text-sm font-semibold text-on-surface">
            Cards per session
          </label>
          <span className="text-sm font-bold text-primary">{maxCardsPerReview}</span>
        </div>
        <input
          id="max-cards"
          type="range"
          role="slider"
          min={5}
          max={100}
          step={5}
          value={maxCardsPerReview}
          onChange={(e) => setMaxCardsPerReview(Number(e.target.value))}
          className="w-full h-2 bg-surface-container rounded-full appearance-none cursor-pointer accent-primary"
          aria-valuemin={5}
          aria-valuemax={100}
          aria-valuenow={maxCardsPerReview}
          aria-valuetext={`${maxCardsPerReview} cards`}
        />
        <div className="flex justify-between mt-1">
          <span className="text-[10px] text-on-surface-variant">5</span>
          <span className="text-[10px] text-on-surface-variant">100</span>
        </div>
      </div>
    </div>
  )
}
